import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
    selector: 'app-cost-center-list',
    templateUrl: './../../../templates/forms/modals/employee-position-list.component.html',
})
export class JobTitleNameListComponent implements OnInit {


    @Input()
    modalShow: boolean = true;


    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "JobTitleNameListid"

    dataObj: any;
    jobTitleNameList = [];
    searchFields: any[] = ['JOBTITLE', 'HR_TYPE_NAME', 'GRADE_STEP', 'GRADE', 'GRADE_INFO', 'STEP_BASIC', 'RULE_DATE'];
    public searchString;
    constructor(
        public langService: LangService,
        public gridService: GridService,
        private dataLoadService: DataLoadService) {
        this.colObj = [
            { headerName: langService.langData.jobTitle, field: 'JOBTITLE', sortable: true, resizable: true, hide: false },
            { headerName: 'HR_TYPE_NAME', field: 'HR_TYPE_NAME', sortable: true, resizable: true, hide: false },
            { headerName: 'JOB_TYPE_NAME', field: 'JOB_TYPE_NAME', sortable: true, resizable: true, hide: false },
            { headerName: 'GRADE_STEP', field: 'GRADE_STEP', sortable: true, resizable: true, hide: false },
            { headerName: 'GRADE', field: 'GRADE', sortable: true, resizable: true, hide: false },
            { headerName: 'GRADE_INFO', field: 'GRADE_INFO', sortable: true, resizable: true, hide: false },
            { headerName: 'STEP_BASIC', field: 'STEP_BASIC', sortable: true, resizable: true, hide: false },
            { headerName: 'RULE_DATE', field: 'RULE_DATE', sortable: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);
    
        this.dataLoadService.load('FG_HR1002_JOBTITLE_LIST',  JSON.parse(JSON.stringify({P_COMPANY_NO: 1}))).subscribe(result => {
            this.jobTitleNameList =  result.body;
        })

    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}
